var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('Modal', {
    attrs: {
      "title": _vm.tipText.title,
      "width": "625",
      "mask-closable": false
    },
    scopedSlots: _vm._u([{
      key: "footer",
      fn: function () {
        return [_c('footer', {
          staticClass: "flex gap-2 justify-end"
        }, [_c('Button', {
          on: {
            "click": _vm.cancel
          }
        }, [_vm._v(_vm._s(_vm.tipText.cancelBtn))]), _c('Button', {
          attrs: {
            "type": "primary"
          },
          on: {
            "click": _vm.submit
          }
        }, [_vm._v(_vm._s(_vm.tipText.confirmBtn))])], 1)];
      },
      proxy: true
    }]),
    model: {
      value: _vm.visible,
      callback: function ($$v) {
        _vm.visible = $$v;
      },
      expression: "visible"
    }
  }, [_vm.tipText.tip ? _c('header', {
    staticClass: "password-modal-subtitle"
  }, [_vm._v(" " + _vm._s(_vm.tipText.tip) + " ")]) : _vm._e(), _c('main', {
    staticClass: "p-4 flex items-center justify-center"
  }, [_c('Form', {
    ref: "form",
    staticClass: "w-[400px]",
    attrs: {
      "model": _vm.form,
      "rules": _vm.rules,
      "label-position": "top"
    }
  }, [_c('password-input', {
    ref: "formPsd",
    attrs: {
      "label": $t("d7qei74", "新密码:"),
      "placeholder": $t("7j1yla6", "请输入新密码")
    },
    model: {
      value: _vm.form.newPase,
      callback: function ($$v) {
        _vm.$set(_vm.form, "newPase", $$v);
      },
      expression: "form.newPase"
    }
  }), _c('FormItem', {
    attrs: {
      "label": $t("frqaup4", "确认密码"),
      "prop": "surePsd"
    }
  }, [_c('Input', {
    attrs: {
      "type": _vm.inputType.type,
      "placeholder": $t("hrcq067", "请输入确认密码")
    },
    scopedSlots: _vm._u([{
      key: "suffix",
      fn: function () {
        return [_c('Icon', {
          attrs: {
            "type": _vm.inputType.icon
          },
          on: {
            "click": _vm.changeEye
          }
        })];
      },
      proxy: true
    }]),
    model: {
      value: _vm.form.surePsd,
      callback: function ($$v) {
        _vm.$set(_vm.form, "surePsd", $$v);
      },
      expression: "form.surePsd"
    }
  })], 1), _c('FormItem', [_c('div', {
    staticClass: "tip flex gap-2"
  }, [_c('Icon', {
    staticClass: "leading-[21px]",
    attrs: {
      "type": "md-alert"
    }
  }), _c('p', {
    staticClass: "max-w-[345px]"
  }, [_vm._v(` ${$t("4tppx119", "密码要求（至少8位，包含大小写字母、数字、符号） 安全建议：避免使用生日、连续数字等弱密码")} `)])], 1)])], 1)], 1)]);
};
var staticRenderFns = [];
export { render, staticRenderFns };